import React, { Component } from 'react'
import styled from 'styled-components'
import { SimpleArrowButton } from '@ubiwherenpm/adene-ui-components'

import Loading from 'components/Loading'
import Error from 'components/Error'

import Navbar from 'containers/Navbar'

import Functions from 'validations'

import mapValues from 'lodash/mapValues'
import isFunction from 'lodash/isFunction'
import first from 'lodash/first'
import last from 'lodash/last'
import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
import { backgroundColors } from 'config'
import isEqual from 'lodash/isEqual'

export default class Form extends Component {
  /**
   * Validates form fields based on flowfields sent
   * by props
   */
  isFormValid() {
    const { values, fields } = this.props
    let invalid = {}

    mapValues(fields, (validations, key) => {
      let multiple = key.indexOf(',') !== -1
      let fields = [values[key]]

      // Multiple params validation
      if (multiple) {
        let valueNames = key.split(',')
        fields = valueNames.map((name) => {
          return values[name]
        })
      }

      let validatorNameInAsValues = false
      let shouldDoTheRest = true
      const firstValidation = first(validations)
      mapValues(values, (value, key) => {
        if (firstValidation === key) {
          validatorNameInAsValues = Functions[firstValidation]
        }
      })

      // Only passs if value in Values
      if (validatorNameInAsValues !== false) {
        if (!validatorNameInAsValues(values)) {
          shouldDoTheRest = false
        } else {
          validations.shift()
        }
      }

      // Ignore all if validation matches
      if (firstValidation && firstValidation.indexOf('ignoreIf') !== -1) {
        const validation = last(firstValidation.split('.'))
        if (Functions[validation](values)) {
          shouldDoTheRest = false
        }
      }

      if (shouldDoTheRest) {
        for (var index = 0; index < validations.length; index++) {
          const validation = validations[index]
          const validator = Functions[validation]

          if (isFunction(validator)) {
            const validationResult = validator(...fields, values)
            if (isObject(validationResult)) {
              if (validationResult.flag) {
                invalid[key] = validationResult
                break
              }
            } else {
              if (validationResult) {
                invalid[key] = validation
                break
              }
            }
          }
        }
      }
    })
    return { valid: isEmpty(invalid), invalid }
  }

  /**
   * Stuff to do on first mount
   */
  componentDidMount() {
    // // Scrols to top on component mount
    // setTimeout(() => {
    //   const element = document.getElementById('anchor')
    //   if (element) {
    //     element.scroll({ top: 0, behavior: 'smooth' })
    //   }
    // }, 100)
  }

  /**
   * Refresh invalids
   */
  componentDidUpdate() {
    const currentInvalid = this.props.invalid
    const { setInvalid } = this.actions

    // Update invalids on changes
    if (!isEmpty(currentInvalid)) {
      const { valid, invalid } = this.isFormValid()

      if (!isEqual(currentInvalid, invalid)) {
        if (valid) {
          setInvalid({})
        } else {
          setInvalid(invalid)
        }
      }
    }
  }

  /**
   * Renderes the navbar
   */
  renderNavbar() {
    const { router } = this.props
    return <Navbar router={router} id={`navbar-simulator`} />
  }

  /**
   * Renders the top info
   */
  renderTop() {
    const { loading, error } = this.props

    if (loading) {
      return <Loading />
    }

    if (error) {
      return <Error />
    }
  }

  /**
   * Renders the buttons
   */
  renderButtons(isLoading = false) {
    return (
      <ButtonWrapper id={`buttons-simulator`}>
        {this.prev && (
          <StyledButton
            bgNormalColor={backgroundColors.normalRight}
            bgOverColor={backgroundColors.overRightRight}
            arrowLeft
            left
            reverse
            strokeColor={`#FFFFFF`}
            onClick={() => this.prev()}>
            <strong>{this.prevText}</strong>
          </StyledButton>
        )}
        {this.next && (
          <StyledButton
            bgNormalColor={backgroundColors.normalLeft}
            bgOverColor={backgroundColors.overLeftLeft}
            arrowRight
            disabled={isLoading}
            right
            strokeColor={`#FFFFFF`}
            onClick={() => {
              if (!isLoading) {
                this.next()
              }
            }}>
            <strong>{this.nextText}</strong>
          </StyledButton>
        )}
      </ButtonWrapper>
    )
  }
}

const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-evenly;
  align-items: stretch;
  align-content: center;
`

const StyledButton = styled(SimpleArrowButton)`
  background: ${({ bgNormalColor }) => bgNormalColor};
  border: none;
  font-size: 20px;
  letter-spacing: 1px;
  line-height: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  color: #FFFFFF;
  font-family: 'Nunito', 'Helvetica Neue', sans-serif;

  font-weight: bold;
  transition: all 0.3s ease-in-out;
  border-radius: 0px;

  display: flex;
  align-items: center;
  justify-content: center;

  order: 1;
  flex-grow: 1;
  flex-basis: 50%;

  > strong {
    margin: 0 10px;
  }

  > span {
    margin: 0;
    height: 12px;
    width: 12px;
    margin-top: -2px;
    transition: all 0.2s ease-in-out;
  }

  &:first-child {
    margin-right: 1px;
  }

  &:hover {
    color: #FFFFFF;

    ${({ right, bgOverColor }) =>
      right ? `padding-left: 30px;` : `padding-right: 30px;`}
    background: ${({ bgOverColor }) => bgOverColor};

    > span {
      ${({ right }) => (right ? `margin-right: -10px;` : `margin-left: -10px;`)}
    }
  }

  @media screen and (max-width: 468px) {
    font-size: 16px;
  }
`



// WEBPACK FOOTER //
// ./src/containers/Form/index.js